import { createContext } from "react";

export type UsuarioContextType = {
  nome: String;
};

export const UsuarioContext = createContext<UsuarioContextType>(null!);
